/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsOptimizedAwsAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsOptimizedAwsAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsOptimizedAwsAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsOptimizedAwsAdvisorResource>): RecommendationForFinopsOptimizedAwsAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsOptimizedAwsAdvisorResource(), model);
        RecommendationForFinopsOptimizedAwsAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsOptimizedAwsAdvisorResource>): RecommendationForFinopsOptimizedAwsAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsOptimizedAwsAdvisorResource.newInstance(<RecommendationForFinopsOptimizedAwsAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsOptimizedAwsAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsOptimizedAwsAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsOptimizedAwsAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsOptimizedAwsAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
